/** Iniciais para avatar: "Ana Souza" → "AS", "ana" → "AN", vazio → "?". */
export function getInitials(name: string | null | undefined): string {
  const words = (name ?? "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

/** "1 freelancer", "3 freelancers". Plural simples com sufixo. */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count.toLocaleString("pt-BR")} ${count === 1 ? singular : plural}`;
}
